




















import Vue from "vue";
import { BaseVue } from "./base";
import { Component, Prop } from "vue-property-decorator";
import { Base, Question, PanelModel } from "survey-core";

@Component
export class Errors extends BaseVue {
  @Prop() element: Question | PanelModel;
  @Prop() location: String;
  protected getModel(): Base {
    return this.element;
  }
}
Vue.component("survey-errors", Errors);
export default Errors;
